export default "__VITE_ASSET__6ab3fcf9__"